import { useTranslation } from "react-i18next";
import { ReactComponent as Withdraw } from "assets/icons/withdraw.svg";
import { ReactComponent as Deposit } from "assets/icons/deposit.svg";
import { digitsEnToFa } from "@persian-tools/persian-tools";

const BankActivation = ({
  withdraw,
  className,
  name,
  date,
  amount = 0,
  // balance = 0,
  type,
  tran_key,
  description,
}) => {
  const { t } = useTranslation();

  const text = withdraw ? "text-error-0" : "text-primary-0";

  const renderTitle = () => {
    switch (type?.toLowerCase()) {
      case "profit":
        return "سود";

      case "withdraw":
        return "برداشت از حساب";

      case "deposit":
        return "واریز به حساب";

      case "fee":
        return "کارمزد";

      default:
        return "";
    }
  };
  const renderIcon = () => {
    switch (type?.toLowerCase()) {
      case "deposit":
        return <Deposit className="w-8 h-8" />;

      case "profit":
        return <amountUp className="w-6 h-11" />;

      case "withdraw":
      case "fee":
        return <Withdraw className="w-8 h-8" />;

      default:
        return [];
    }
  };

  return (
    <div
      className={`w-full relative text-center px-4  rounded-lg ${className} z-20`}
    >
      <div className="w-12 h-12 table m-auto mb-2 mt-4">
        <div className="w-12 h-12 relative flex justify-center items-center">
          {renderIcon()}
        </div>
      </div>
      <div className={`text-center ${text} body-16px-medium mb-3`}>
        {renderTitle()}
      </div>
      <div className="body-16px-medium text-gray-4">{name}</div>
      <div className="body-14px-medium tracking-normal text-gray-0 ">
        {digitsEnToFa(date).toLocaleString()}
      </div>
      <div className="flex gap-1 justify-center">
        <span className="h-20px-demibold text-gray-4">
          {digitsEnToFa(Number(amount).toLocaleString())}
        </span>
        <span className="body-16px-regular text-gray-4">{t("rial")}</span>
      </div>
      <div className="pt-5 mt-5 border-t border-gary--8">
        {/* <div className="flex justify-between items-center">
          <span className="body-14px-medium tracking-normal text-gray-0 mb-3">
            {t("bank.balance-after-transaction")}
          </span>
          <div className="flex gap-1 justify-center">
            <span className="body-14px-medium tracking-normal text-gray-4">
              {Number(balance).toLocaleString()}
            </span>
            <span>{t("rial")}</span>
          </div>
        </div> */}
        <div className="flex justify-between items-center">
          <span className="body-14px-medium tracking-normal text-gray-0 ">
            {t("bank.payment-id")}
          </span>
          <span className="body-14px-medium tracking-normal text-gray-4">
            {digitsEnToFa(tran_key)}
          </span>
        </div>
        <div className="pt-5 mt-5 mb-5 border-t border-gary--8 text-right">
          <div className="body-14px-medium tracking-normal text-gray-0 mb-3 ">
            {t("bank.receipt-description")}
          </div>
          <div className="body-14px-medium tracking-normal text-gray-4 bg-gray--12 rounded-lg p-2">
            {digitsEnToFa(description)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankActivation;
